export const SUBMIT_FEATURE_REQUEST_AND_BUG_URL =
  'https://river.amazon.com/?org=GMH&q0=10d16e8f-dba1-48a0-82ca-2e31c1a8ef59';
export const BADGE_PHOTO_THUMBNAIL_URL = 'https://badgephotos.corp.amazon.com/?uid=';
export const RTW_WIKI_URL = 'https://w.amazon.com/bin/view/HealthSolutions/ReturnToWork/';
export const WEBHOOKS_LINK = 'https://w.amazon.com/bin/view/HealthSolutions/ReturnToWork/Webhooks';
export const RTW_FAQ_LINK = 'https://w.amazon.com/bin/view/HealthSolutions/ReturnToWork/FAQs/';
export const RTW_TRAINING_LINK = 'https://w.amazon.com/bin/view/HealthSolutions/ReturnToWork/Training/';
export const PHONE_TOOL_URL = 'https://phonetool.amazon.com/users/';
export const JOB_MODIFICATIONS_WIKI_LINK =
  'https://w.amazon.com/bin/view/Whs/gmh/health-solutions/rtw/job-modifications/';
export const T2_JOB_REFERENCE_CARD =
  'https://amazon.awsapps.com/workdocs-amazon/index.html#/document/94d5e6c587e587adaddba230ccea22a6a52a76d2d2bf0870a19e6d5e3debb527';
export const RTW_DASHBOARD_LINK =
  'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/dashboards/cd666525-ba21-408b-adc4-86b70471f3f8/sheets/cd666525-ba21-408b-adc4-86b70471f3f8_7b7f69d3-111c-48eb-903b-d2188ed6c7c2';
export const ACCOMMODATION_PROCESS_REFERENCE_CARD =
  'https://w.amazon.com/bin/view/Whs/gmh/health-solutions/rtw/accommodations-process-network-guidance/';
export const PRIORITIZATION_ORDER_REFERENCE_CARD =
  'https://amazon.awsapps.com/workdocs-amazon/index.html#/document/d71d9874be9dfb1fd04a997528030333776972afab8cfda0b4ba07012dc092d9';
export const PERSONA_REFERENCE_CARD =
  'https://amazon.awsapps.com/workdocs-amazon/index.html#/document/125ddd6ff5e3561cb847241737a87ecc2bd4936e77cf7e7a5094561f536699c4';
